import { useState, useEffect, useCallback } from "react";

import CompellonApi from "apis/compellon";

const useJobResultData = (outputs, setOutputs, key) => {
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async id => {
    setLoading(true);
    try {
      const { data } = await CompellonApi.fetchJobResultOutput({
        job_output_id: id,
      });
      setOutputs(prev => ({ ...prev, [key]: data }));
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (outputs?.[key]?.result) setLoading(false);
    else if (outputs?.[key]?.id) fetchData(outputs[key].id);
  }, [outputs?.[key]]);

  return { loading, data: outputs?.[key]?.result };
};

export default useJobResultData;
